const DocumentHome = () => import('@/components/Shared/Documentation/documentation.template.vue')
const OverviewDoc = () => import('@/components/Shared/Documentation/overview.documentation.vue')
const StartNuha = () => import('@/components/Shared/Documentation/satrtNuha.documentation.vue')

const BuildDoc= () => import('@/components/Shared/Documentation/build.documentation.vue')
const ManageDoc= () => import('@/components/Shared/Documentation/manage.documentation.vue')
const PublishDoc= () => import('@/components/Shared/Documentation/documetation.publish.vue')
const EntitiesDoc= () => import('@/components/Shared/Documentation/entities.documentation.vue')
const TrainDoc= () => import('@/components/Shared/Documentation/train.documentation.vue')
const TestDoc= () => import('@/components/Shared/Documentation/test.documentation.vue')

export default [
  {
    path: 'document',
    name: 'documentation',
    meta:{
      title: 'document',
      subtitle: 'document'
    },
    component: DocumentHome
  },
  {
    path: 'TestDoc',
    name: 'doc-test',
    meta: {
      title: 'TestDoc',
      subtitle: 'TestDoc'
    },
    component: TestDoc
  },
  {
    path: 'TrainDoc',
    name: 'doc-train',
    meta: {
      title: 'TrainDoc',
      subtitle: 'TrainDoc'
    },
    component: TrainDoc
  },
  {
    path: 'EntitiesDoc',
    name: 'doc-entities',
    meta: {
      title: 'EntitiesDoc',
      subtitle: 'EntitiesDoc'
    },
    component: EntitiesDoc
  },
  {
    path: 'BuildDoc',
    name: 'doc-build',
    meta: {
      title: 'BuildDoc',
      subtitle: 'BuildDoc'
    },
    component: BuildDoc
  },
  {
    path: 'PublishDoc',
    name: 'doc-pubiish',
    meta: {
      title: 'PublishDoc',
      subtitle: 'PublishDoc'
    },
    component: PublishDoc
  },
  {
    path: 'OverviewDoc',
    name: 'doc-overview',
    meta: {
      title: 'OverviewDoc',
      subtitle: 'OverviewDoc'
    },
    component: OverviewDoc
  },
  {
    path: 'StartNuha',
    name: 'doc-startNuha',
    meta: {
      title: 'StartNuha',
      subtitle: 'StartNuha'
    },
    component: StartNuha
  },
  {
    path: 'ManageDoc',
    name: 'doc-manage',
    meta: {
      title: 'ManageDoc',
      subtitle: 'ManageDoc'
    },
    component: ManageDoc
  }
  
]


// WEBPACK FOOTER //
// ./src/router/doc.router.js